export default "__VITE_PUBLIC_ASSET__0b42776b__"